import React, { useState } from "react";
import { LogoIcon } from "../../assets/icons";
import Theme from "../../assets/ui/theme";
import {
  HamburgerIcon,
  StyledHamburger,
  StyledNav,
  StyledNavbar,
  StyledNavLink,
  StyledWorkWithUs,
  StyledNavbarWrapper
} from "./ui";
import { scrollToTheComponent } from "../../utils";
import {withRouter} from "react-router-dom";

const vmsLink = 'https://vms.staging.exsportia.com';
const TopNav = ({history}) => {
  const [showNavSection, toggleTopNav] = useState(false);

  const scrollTo = id => {
    scrollToTheComponent(id);
    toggleTopNav(false);
  };

  const goToVms = () => {
    const win = window.open(vmsLink, '_blank');
      win.focus();
  };

    return (
    <StyledNavbarWrapper>
      <StyledNavbar>
        <LogoIcon onClick={() => history.replace("/")}/>
        <StyledNav active={showNavSection}>
          <StyledNavLink budgeColor={Theme.colors.mainPink} onClick={goToVms}>
            Exportia.com
          </StyledNavLink>
          <StyledNavLink
            budgeColor={Theme.colors.mainGreen}
            onClick={goToVms}
          >
            Venue management
          </StyledNavLink>
          <StyledNavLink
            budgeColor={Theme.colors.mainYellow}
            onClick={goToVms}
          >
            Teacher&trainers
          </StyledNavLink>
          <StyledWorkWithUs onClick={() => history.push("/work-with-us")}>Work with us</StyledWorkWithUs>
        </StyledNav>
        <StyledHamburger
          onClick={() => toggleTopNav(!showNavSection)}
          display={["block", null, null, "none"]}
        >
          <HamburgerIcon active={showNavSection}>
            <span />
            <span />
            <span />
          </HamburgerIcon>
        </StyledHamburger>
      </StyledNavbar>
    </StyledNavbarWrapper>
  );
};

export default withRouter(TopNav);
